import { type DirectiveBinding } from 'vue';
import { type Router, type RouteRecordRaw } from 'vue-router';

export const link = {
    mounted: (el: HTMLElement, binding: DirectiveBinding): void => {
        const [router, route]: [Router, RouteRecordRaw | (() => RouteRecordRaw) | string | undefined] = binding.value;

        el.addEventListener('pointerdown', (event: MouseEvent): void => {
            if (!route) {
                return;
            }
            if (typeof route === 'function') {
                event.preventDefault();
                switch (event.button) {
                    case 0:
                        if (!event.shiftKey) {
                            router.push(route());
                            return;
                        }
                        window.open(router.resolve(route()).href, '_blank', 'noopener,noreferrer');
                        return;
                    case 1:
                        window.open(router.resolve(route()).href, '_blank');
                        return;
                }
            }
            else if (typeof route === 'object') {
                event.preventDefault();
                switch (event.button) {
                    case 0:
                        if (!event.shiftKey) {
                            router.push(route);
                            return;
                        }
                        window.open(router.resolve(route).href, '_blank', 'noopener,noreferrer');
                        return;
                    case 1:
                        window.open(router.resolve(route).href, '_blank');
                        return;
                }
            }
            else if (typeof route === 'string') {
                event.preventDefault();
                window.open(route, '_blank');
                return;
            }
        });
    }
};